/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Dropbox_ListInputs */

const es_tools_dropbox_list = /** @type {(inputs: Tools_Dropbox_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listando carpeta de Dropbox...`)
};

const en_tools_dropbox_list = /** @type {(inputs: Tools_Dropbox_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Dropbox folder...`)
};

/**
* | output |
* | --- |
* | "Listing Dropbox folder..." |
*
* @param {Tools_Dropbox_ListInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_dropbox_list = /** @type {((inputs?: Tools_Dropbox_ListInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Dropbox_ListInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_dropbox_list(inputs)
	return en_tools_dropbox_list(inputs)
});
export { tools_dropbox_list as "tools.dropbox.list" }